import yup from 'src/libs/yup';

const CommonQuestionFilterSchema = yup.object().shape({
  title: yup.string().label('Título'),
  answer: yup.string().label('Resposta'),
  status: yup.string().nullable().label('Status'),
});

export default CommonQuestionFilterSchema;
